import { axiosInstance2 } from "../../utils/axiosConfig";
import { apiStart, apiComplete, apiFail } from "./common";
import moment from 'moment';
import * as actionTypes from "./actionTypes";
import { message } from "antd";

const CONTENT_JSON_HEADER = {
    "Content-Type": "application/json"
}

export const getComplianceTableDataSuccess = data => {
    return {
        type: actionTypes.GET_COMPLIANCE_TABLE_DATA_SUCCESS,
        data: data
    }
}
export const getComplianceTableDataError = data => {
    return {
        type: actionTypes.GET_COMPLIANCE_TABLE_DATA_ERROR,
        data: data
    }
}
export const getHolisticDataSuccess = data => {
    return {
        type: actionTypes.GET_HOLISTIC_DATA_SUCCESS,
        data: data
    }
}
export const getAppConfigDataSuccess = data => {
    return {
        type: actionTypes.GET_APP_CONFIG_DATA_SUCCESS,
        data: data
    }
}
export const getExcelExportDataSuccess = data => {
    return {
        type: actionTypes.GET_EXCEL_EXPORT_DATA_SUCCESS,
        data: data
    }
}

export const getComplianceReportCategorySuccess = data => {
    return {
        type: actionTypes.GET_COMP_REPORT_CAT_SUCCESS,
        data: data
    }
}

export const getComplianceReportCategoryError = data => {
    return {
        type: actionTypes.GET_COMP_REPORT_CAT_FAIL,
        data: data
    }
}

export const getAppConfig = (params) => {
    return async dispatch => {
        dispatch(apiStart());
        await axiosInstance2.post('/api/callExternal/getAppConfig',
            params,
            // CONTENT_JSON_HEADER
        )
        .then(response => {

            if (response["data"]["error"]) {
                console.error("ERROR :", response["data"]["errorMessage"]);
                let errorMessage = (response["data"]["display"] !== undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occurred';
                message.error(errorMessage);
                dispatch(apiFail(errorMessage));
            } else {
                let configData = response["data"]["data"];
                dispatch(apiComplete());
                dispatch(getAppConfigDataSuccess(configData));

            }
        }).catch(error => {
            console.error("ERROR :", error);
            message.error("Cannot reach server");
            dispatch(apiFail("Cannot reach server"));
        })
    }
}

export const getHolisticData = (params) => {
    return async dispatch => {
        dispatch(apiStart());
        await axiosInstance2.post('/api/callExternal/getHolisticHotelData',
            params,
            CONTENT_JSON_HEADER
        ).then(response => {

            if (response["data"]["error"]) {
                console.error("WARN :", response["data"]["errorMessage"]);
                let errorMessage = (response["data"]["display"] !== undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occurred';
                // message.warn(errorMessage);
                dispatch(apiComplete());
                dispatch(getHolisticDataSuccess({
                    info:'WARN: '+errorMessage,
                    data:[],
                    timestamp:moment()
                })); //normally the error will be hmg not found - this need to ignore
            } else {
                let holisticData = [];
                holisticData = response["data"]["data"].map(hotel => {
                    return {
                        "name": hotel.name,
                        "code": hotel.code,
                        "codeEnv": hotel.code + '-' + hotel.env,
                        "label": hotel.code + ' - ' + hotel.name,
                        "env": hotel.env,
                        "entityId": hotel.entityId,
                        "projectId": hotel.projectId,
                        "status": hotel.status,
                        "goLiveDate": hotel.goLiveDate,
                        "sigGoLiveDate": hotel.sigGoLiveDate,
                        "signType": hotel.signType,
                        "envlopeTriggerType": hotel.envlopeTriggerType,
                        "timeZone": hotel.timeZone,
                        "pms": hotel.pms,
                        "id": hotel.id,
                        "customViewTypes": hotel.customViewTypes
                    }
                });
                dispatch(apiComplete());
                dispatch(getHolisticDataSuccess({
                    info:'SUCCESS',
                    data:holisticData,
                    timestamp:moment()
                }));

            }
        }).catch(error => {
            console.error("ERROR :", error);
            message.error("Cannot reach server");
            dispatch(apiFail("Cannot reach server"));
        })
    }
}

export const getComplianceTableData = (params) => {
    return async dispatch => {
        dispatch(apiStart());
        await axiosInstance2.post(
            '/api/compliance/queryComplianceTableData',
            params,
            { headers: CONTENT_JSON_HEADER }
        ).then(response => {
            if (response["data"]["error"]) {
                console.error("ERROR :", response["data"]["errorMessage"]);

                let errorMessage = (response["data"]["display"] !== undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occurred';
                let passResponse = {
                    "tabType" : response.data.tabView,
                    "status" : []
                }
                dispatch(getComplianceTableDataError(passResponse));
                message.error(errorMessage);
                dispatch(apiFail(errorMessage));
            } else {
                dispatch(apiComplete());
                let passResponse = {
                    "tabType" : response.data.tabView,
                    "status" : response.data.status
                }
                dispatch(getComplianceTableDataSuccess(passResponse));
                
                // return response.data.data;
            }
        }).catch(error => {
            console.error("ERROR :", error);
            message.error("Cannot reach server");
            dispatch(apiFail("Cannot reach server"));
            return;
        });
    }

}

export const getExcelExportData = (params) => {
    return async dispatch => {
        dispatch(apiStart());
        var headerType = CONTENT_JSON_HEADER;
        if (!params.sendEmail) {
            headerType = 'blob'
        }
        await axiosInstance2.post(
            '/api/compliance/excelExportFile',
            params,
            {
                responseType: headerType,
            }
        ).then(response => {
            if (response["data"]["error"]) {
                console.error("ERROR :", response["data"]["errorMessage"]);

                let errorMessage = (response["data"]["display"] !== undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occured';
                message.error(errorMessage);
                dispatch(apiFail(errorMessage));
            } else {
                dispatch(apiComplete())
                if (!params.sendEmail) {
                    message.success("Excel downloaded successfully");
                } else {
                    if (response["data"]["display"] !== undefined && response["data"]["display"]) {
                        message.success(response["data"]["errorMessage"]);
                    } else {
                        message.success("Email sent successfully");
                    }
                }
                dispatch(getExcelExportDataSuccess(response));
            }
        }).catch(error => {
            console.error("ERROR :", error);
            message.error("Cannot reach server");
            dispatch(apiFail("Cannot reach server"));
        });
    }

}

export const resendEnvelopToNotSigned = (params) => {

}

//Get hotel wise report categories for compliance
export const getComplianceHotelReportCategoryData = (params) => {
    return async dispatch => {
        dispatch(apiStart());
        await axiosInstance2.post(
            '/api/userHotels/getMultipleHotelReportData',
            params,
            { headers: CONTENT_JSON_HEADER }
        ).then(response => {
            if (response["data"]["error"]) {
                console.error("ERROR :", response["data"]["errorMessage"]);

                let errorMessage = (response["data"]["display"] !== undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occured';
                
                dispatch(getComplianceReportCategoryError({
                    hotelsReportsMappedCategories : [],//using for category
                    hotelsCategoriesMappedReports : [],//use for reports
                    // noCategoryReports : false,
                    // reportsExist : false
                }));
                message.error(errorMessage);
                dispatch(apiFail(errorMessage));
            } else {
                dispatch(apiComplete());
                
                dispatch(getComplianceReportCategorySuccess({
                    hotelsReportsMappedCategories: response["data"]["hotelsReportsMappedCategories"],//using for category
                    hotelsCategoriesMappedReports: response["data"]["hotelsCategoriesMappedReports"],//use for reports
                    // hotelReportCategories : response["data"]["hotelReportCategories"],
                    // noCategoryReports : response["data"]["noCategoryReports"],
                    // reportsExist : response["data"]["reportsExist"]
                }));
                
                // return response.data.data;
            }
        }).catch(error => {
            console.error("ERROR :", error);
            message.error("Cannot reach server");
            dispatch(apiFail("Cannot reach server"));
            return;
        });
    }

}